import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useGetMetadataQuery from '../../reactQuery/hooks/useGetMetadata';
import SubscriptionPlanCard from './SubscriptionPlanCard';
import PlansImg from '../../static/assets/homepage/plans-img.svg';
import { RootState } from '@/redux/store';
import './SubscriptionPlan.scss';

const SubscriptionPlan: FC = () => {
	const { t } = useTranslation();
	const { data: metadata } = useGetMetadataQuery();
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	const version = 'v2';

	return version === 'v2' ? (
		<section>
			<div className="internal-wrapper">
				<div className="home-section-header">
					<Typography
						variant="h2"
						sx={{
							fontWeight: '600',
							fontSize: '49px',
							lineHeight: '150%',
						}}
					>
						Subscription plans
					</Typography>
					<Typography
						sx={{
							fontSize: '25px',
							// color: #79777c;
							opacity: 0.65,
							lineHeight: '145%',
						}}
					>
						Start free to explore or go fully loaded
					</Typography>
				</div>
			</div>
			<div
				className="home-plans__wrapper"
				style={{
					background: isDarkTheme
						? '#333'
						: `radial-gradient(
				270.86% 72.14% at 100% 0%,
				rgba(241, 234, 251, 0.4) 0%,
				rgba(246, 245, 247, 0) 100%
			),
			radial-gradient(
				84.9% 26.15% at 50% 50%,
				rgba(255, 247, 240, 0.4) 0%,
				rgba(246, 245, 247, 0.4) 100%
			),
			var(--Gray-Surface-Subtle, #f6f5f7);`,
				}}
			>
				<div className="internal-wrapper">
					<div className="home-plans__internal-wrapper">
						<div className="home-plans__items-wrapper">
							{metadata?.subscriptionPlans?.map((subscriptionPlan) => (
								<div key={subscriptionPlan.name}>
									<SubscriptionPlanCard subscriptionPlan={subscriptionPlan} />
								</div>
							))}
						</div>
						<div className="home-plans__img-wrapper">
							<img
								className="home-plans__img img-block"
								src={PlansImg}
								alt="Codeway.TODAY"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	) : (
		<div className="SubscriptionPlan">
			<div className="SubscriptionPlan__header">
				<Typography
					variant="h3"
					component="h1"
					className="SubscriptionPlan__title"
					sx={{ fontWeight: '600' }}
				>
					{t('subscriptionPlans')}11
				</Typography>
				<Typography variant="body1" component="p">
					{t('subscriptionSlogan')}
				</Typography>
			</div>
			<div className="SubscriptionPlan__img">
				<img
					src="https://static.codeway.today/image/1705869323434.png"
					alt="subscribe"
				/>
			</div>
			<div className="SubscriptionPlan__wrapper">
				{metadata?.subscriptionPlans?.map((subscriptionPlan) => (
					<div key={subscriptionPlan.name}>
						<SubscriptionPlanCard subscriptionPlan={subscriptionPlan} />
					</div>
				))}
			</div>
		</div>
	);
};

export default SubscriptionPlan;
